export enum EventEmitterTypes {
	Refresh = 'Refresh',
	BeginLoading = 'BeginLoading',
	EndLoading = 'EndLoading',
	Insert = 'Insert'
}
